import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '../../utils';
import { Card } from '../Card';
import { FormFlex } from '../FormGrid';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
export const Comment = (props) => {
    const { children, author, created } = props;
    return (_jsxs(CommentRootStyled, { children: [children, (author || created) && (_jsxs(FormFlex, { columnGap: 2, rowGap: 2, justifyContent: "space-between", children: [author && (_jsxs(FormFlex, { columnGap: 1, rowGap: 2, align: "center", disableWrapChild: true, children: [_jsx(Icon, { fontSize: "small", variant: "headphones" }), _jsx(Typography, { variant: "caption", children: author })] })), created && _jsx(Typography, { variant: "caption", children: created })] }))] }));
};
const CommentRootStyled = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3),
    backgroundColor: theme.palette.info.main,
    color: theme.palette.secondary.dark,
    boxShadow: 'none',
    display: 'grid',
    gap: theme.spacing(2),
}));
